import { PARTNER_SOLUTIONS_BASE_DOC_URL } from 'app/developer-v3/constants';

export default {
  routes: {
    '.': {
      onEnter({ routeTo }) {
        routeTo(`${PARTNER_SOLUTIONS_BASE_DOC_URL}/workflow-api/intro`, {
          exit: true,
        });
      },
    },
  },
};
